var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140",
    "data-name": "Group 140",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M9,2.455A2.094,2.094,0,0,0,7.006,4.636V7.545A2.094,2.094,0,0,0,9,9.727a2.094,2.094,0,0,0,1.994-2.182V4.636A2.094,2.094,0,0,0,9,2.455ZM9,1a3.49,3.49,0,0,1,3.323,3.636V7.545A3.49,3.49,0,0,1,9,11.182,3.49,3.49,0,0,1,5.677,7.545V4.636A3.49,3.49,0,0,1,9,1ZM3.055,8.273H4.394A4.81,4.81,0,0,0,9,12.632,4.81,4.81,0,0,0,13.6,8.273h1.34a6.288,6.288,0,0,1-5.28,5.778V17H8.335V14.051a6.288,6.288,0,0,1-5.28-5.778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.be8abb3b1f5dab7e9cd55a2b5da80ee9.svg";
export { ForwardRef as ReactComponent };